<template>
  <Modal :id="'.cmp-booking-release-add-link    '" @cancelled="onCancel">
    <template slot="header">{{$t('add_link')}}</template>
    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'linkType'"
          required
          v-bind="textFieldConfig"
          v-model="linkType"
          isModel
          :placeholder="$t('Link Type')"
          @valuechanged="onValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'linkDescription'"
          required
          v-bind="textAreaConfig"
          v-model="linkDescription"
          isModel
          :height="80"
          :placeholder="$t('description')"
          @valuechanged="onValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'link'"
          required
          v-bind="textAreaConfig"
          v-model="link"
          isModel
          :placeholder="$t('url')"
          @valuechanged="onValueChange"
        ></TextField>

      </div>


    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 s6" @click.stop="onAddLink">{{$t('add_link')}}</button>
    </template>
  </Modal>
</template>

<script>
import { CountriesTV } from "../../../../models/country.model";
import { Subject } from "rxjs";

import { createTextFieldConfig, EventHooks } from "../../../../plugins/text-field";
import { subscribeSubject } from "../../../../utility";
import { findCountryOfCity } from "../../../../dt-plugins/country";

import Modal from "@dtplugins/modal/modal";

export default {
  components: {
    Modal
  },
  props: {},
  data: function() {
    return {
      linkType: "",
      linkDescription:"",
      link:"",

      textFieldConfig: createTextFieldConfig({
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,

        valueChangedEvent: EventHooks.OnKeyup
      }),
       textAreaConfig: {
        height: 120,
        showEditIconOnHover: false,
        box: true,
        textarea: true,
        showValidationIcons: false
      },
   

     
      locations: []
      // Mark: Data
    };
  },
  mounted: function() {
   
  },
  watch: {},
  computed: {
      external_id: function() {
      return this.$route.query.external_id;
    },
  },
  methods: {
    onValueChange: function(name, value) {
      this.venuename = value;
    
    },

    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onAddLink: function() {
      const payload={link_type:this.linkType,link_description:this.linkDescription,link:this.link}  
      this.$emit("create", payload);
    },


    // Mark: Methods
  }
};
</script>

<style lang="scss">
.cmp-booking-release-add-link {
  .location-list-container {
    width: 100%;
    // height: 190px;
    // overflow: auto;

    table {
      margin-top: 10px;
      width: 100%;

      tbody {
        max-height: 190px;
        overflow: auto;
        min-height: 190px;

        tr {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
